module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kanto-1-4d76aee8f1c4f4d7615498c32a10d12e.png";